import { Params } from '@angular/router';

import { ILogonDocument } from 'app/services/api5-service/api.interface';

import { convertParamsToStringWithEncode } from 'utils/convert-params-to-string';
import { DocHelper } from 'utils/dochelper';

import { RegisterData } from '../model/register-data.interface';

/**
 * Get data for register component from login doc
 *
 * @param loginDoc - Doc for login page
 */
export function mapLoginDocToRegisterData(
  loginDoc?: ILogonDocument,
): RegisterData | null {
  if (!loginDoc || loginDoc.loginform.$register !== 'yes') {
    return null;
  }

  const registerOneselfMessage = DocHelper.getMessage(
    'register_oneself',
    loginDoc,
  );
  const noAccountMessage = DocHelper.getMessage('no_account', loginDoc);

  const paramsForLink: Params = {
    func: 'register',
    lang: loginDoc.$lang,
  };
  const redirect = loginDoc.loginform.redirect?.$;
  if (redirect) {
    paramsForLink.redirect = redirect;
  }
  const queryParams = convertParamsToStringWithEncode(paramsForLink);

  return {
    registerOneselfMessage,
    noAccountMessage,
    link: `${loginDoc.$host}${loginDoc.$binary}?${queryParams}`,
  };
}
